import {
  useAddressRegexPatternsSelector,
  useCountriesSelector,
  useCountrySelectionConfigSelector,
} from "@redux/reducers/appConfig";
import { normaliseCountryValue } from "@lib/resolveCountryOption";
import { USER_FIELDS_NAMES } from "@shared/constants";

const { ADDRESS } = USER_FIELDS_NAMES;

const isValidRegex = pattern => {
  if (!pattern) {
    return false;
  }

  try {
    RegExp(pattern);
    return true;
  } catch {
    return false;
  }
};

export const useAddressPostCodePattern = selectedCountry => {
  const countries = useCountriesSelector();
  const {
    enabled: isCountrySelectionEnabled,
    defaultCountry,
  } = useCountrySelectionConfigSelector();
  const regexPatterns = useAddressRegexPatternsSelector();

  const isCountrySpecific =
    isCountrySelectionEnabled &&
    countries.length > 0 &&
    Boolean(defaultCountry) &&
    Boolean(selectedCountry) &&
    normaliseCountryValue(selectedCountry) !==
      normaliseCountryValue(defaultCountry);

  if (!isCountrySpecific) {
    return regexPatterns[ADDRESS.POST_CODE];
  }

  const match = countries.find(
    option =>
      normaliseCountryValue(option.value) ===
      normaliseCountryValue(selectedCountry)
  );

  if (match && isValidRegex(match.postCodeRegex)) {
    return match.postCodeRegex;
  }

  return regexPatterns.foreignPostCode || undefined;
};
